<template>
	<div class="cents">
		<van-nav-bar :title="this.$t('sbss')" left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="title">
			<div>{{this.$t('kysb')}}</div>
			<div>{{this.$t('ssjg')}}</div>
		</div>
		<!-- 设备添加 -->
		<div v-if="deviceTitle" class="addBox">
			<div class="addTitle">{{deviceTitle}}{{this.$t('sbtj')}}</div>
			<!-- 设备类型 -->
			<div class="inputBox">
				<div class="name">{{this.$t('sblx')}}</div>
				<div class="inputsp">
					<input type="text" :value="deviceType" readonly />
				</div>
			</div>
			<!-- 是否注册机 -->
			<div class="inputBox">
				<div class="name">{{this.$t('sfwzcj')}}</div>
				<div class="inputsp">
					<el-select v-model="registerValue" :placeholder="this.$t('qxz')" size="medium">
						<div style="background-color: #ccc;z-index: 999;width: 180px;margin-left: 13px;" class="liBox">
							<el-option v-for="item in registerOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</div>
					</el-select>
				</div>
			</div>
			<!-- 安装位置 -->
			<div class="inputBox">
				<div class="name">{{this.$t('azwz')}}</div>
				<div class="inputsp">
					<input type="text" v-model="devicePosition" />
				</div>

			</div>
			<!-- 开门状态 -->
			<div class="inputBox">
				<div class="name">{{this.$t('kmzt')}}</div>
				<div class="inputsp">
					<el-select v-model="doorValue" :placeholder="this.$t('qxz')">
						<div
							style="background-color: #ccc;z-index: 999;width: 180px;padding-left: 10px;margin-left: 13px;">
							<el-option v-for="item in doorOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</div>
					</el-select>
				</div>
			</div>
			<!-- 部门选择 -->
			<div class="lisone margin_tops">
				<div class="name">{{$t('qybm')}}</div>
				<div class="inputsp">
					<div class="inputsp" @click="showDep">
						<input type="text" disabled="disabled" v-model="dept_name">
					</div>
					<van-popup v-model="show2" position="bottom" :style="{ height: '50%' }">
						<div style="padding:10px 10px">

							<a-tree style="text-align: left;" v-if="treeData.length" :checkable="true"
								v-model="checkedSiteId" :checkStrictly="true" :tree-data="treeData" defaultExpandAll
								ref="treeForm" :replaceFields="{children:'children', title:'name', key:'id' }"
								@onSelect="onSelect" @check="handleNodeClick">
							</a-tree>

						</div>
					</van-popup>

				</div>
			</div>
			<div v-if="deviceInfo.network==1">
				<!-- wifiSSID设置 -->
				<div class="inputBox" style="margin-top: 20px;">
					<div class="name">wifiSSID</div>
					<div class="inputsp">
						<input type="text" v-model="wifiSSID" />
					</div>
				
				</div>
				<!-- wifiSSID密码 -->
				<div class="inputBox">
					<div class="name">{{this.$t('wifimm')}}</div>
					<div class="inputsp">
						<input type="text" v-model="wifiPassword" />
					</div>
				
				</div>
			</div>
			<!-- 确认按钮 -->
			<div class="btn" @click="confirm">{{this.$t('tj')}}</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	var $ = require('../ble/jquery.min.js');
	var ble_helper = require('../ble/blehelper.js');
	var aes_encrypt  = require('../ble/aes.js');
	var indexs = require('../ble/index.js')
	var current_device = null;
	var current_key = '';
	export default {
		data() {
			return {
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")),
				deviceTitle: '', // 设备名称
				deviceInfo: {}, // 设备信息
				deviceType: '', // 设备类型
				registerOptions: [{
						value: '0',
						label: this.$t('no')
					},
					{
						value: '1',
						label: this.$t('yes')
					}
				],
				registerValue: '1',
				devicePosition: '', // 安装位置
				doorOptions: [{
						value: '0',
						label: this.$t('jin')
					},
					{
						value: '1',
						label: this.$t('chu')
					}
				],
				doorValue: '0', // 开门状态
				show2: false,
				checkedSiteId: [],
				treeData: [],
				dept_name: '',
				dept_id:'', // 部门id
				wifiSSID:'',
				wifiPassword:''
			}
		},
		mounted() {
			this.Blesdom()

		},
		methods: {
			// 设置wifi参数
			setWifiFun(){
				let data = {
					method:'co.wx.device.wifi.set',
					device_id:this.deviceInfo.deviceId,
					wifi_ssid:this.wifiSSID,
					wifi_pwd:this.wifiPassword,
					open_4g:1
				}
				this.$serve(data).then(res=>{
					if(res.data.code==0){
						// Toast.success('WIFI设置成功')
						this.bleSetWifi()
					}else{
						Toast.fail(this.$t('wifiszsbcwm')+res.data.code)
					}
				})
			},
			//发送蓝牙配置WIFI参数
			bleSetWifi() {
				let that = this
				if (this.wifiSSID.length == 0 || this.wifiPassword.length == 0) {
					alert("ssid or password"+this.$t('bnwk'));
					return;
				}
				console.log(ble_helper);
				console.log('device:',current_device);
				console.log('btkey:',current_key)
				// return
				ble_helper.ble_helper.open({
					device: current_device,
					key: current_key,
					onSuccess: function() {
						ble_helper.ble_helper.setNetworkMode({
							mode: 0,
							onSuccess(){
								ble_helper.ble_helper.setWifiSSID({
									ssid: that.wifiSSID,
									onSuccess: function() {
										console.log('setWifiSSID成功');
										ble_helper.ble_helper.setWifiPassword({
											password: that.wifiPassword,
											onSuccess: function() {
												console.log('setWifiPassword成功');
												Toast.success(that.$t('wificsszcg'))
											},
											onFail: function(error) {
												console.log('setWifiPassword失败', error);
												Toast.fail(that.$t('mmszsb'))
											},
										});
									},
									onFail: function(error) {
										console.log('setWifiSSID失败', error);
										Toast.fail('ssid'+that.$t('szsb'))
									},
								});
							},
							onFail: function(error) {
									console.log('setNetworkMode失败', error);
									// Toast.fail('设置网络模式失败!')
									ble_helper.ble_helper.setWifiSSID({
									ssid: that.wifiSSID,
									onSuccess: function() {
										console.log('setWifiSSID成功');
										ble_helper.ble_helper.setWifiPassword({
											password: that.wifiPassword,
											onSuccess: function() {
												console.log('setWifiPassword成功');
												Toast.success(that.$t('wificsszcg'))
											},
											onFail: function(error) {
												console.log('setWifiPassword失败', error);
												Toast.fail(that.$t('mmszsb'))
											},
										});
									},
									onFail: function(error) {
										console.log('setWifiSSID失败', error);
										Toast.fail('ssid'+that.$t('szsb'))
									},
								});
							},
						});
					},
					onFail: function(error) {
						console.log('open失败', error);
						Toast.fail(that.$t('opentips'))
						// ble_helper.ble_helper.setWifiSSID({
						// 			ssid: that.wifiSSID,
						// 			onSuccess: function() {
						// 				console.log('setWifiSSID成功');
						// 				ble_helper.ble_helper.setWifiPassword({
						// 					password: that.wifiPassword,
						// 					onSuccess: function() {
						// 						console.log('setWifiPassword成功');
						// 						Toast.success('WiFi参数设置成功！')
						// 					},
						// 					onFail: function(error) {
						// 						console.log('setWifiPassword失败', error);
						// 						Toast.fail('密码设置失败!')
						// 					},
						// 				});
						// 			},
						// 			onFail: function(error) {
						// 				console.log('setWifiSSID失败', error);
						// 				Toast.fail('ssid设置失败!')
						// 			},
						// 		});
					},
				});
			},

			// 确认添加按钮
			confirm(){
				
				let data = {
					method:'co.device.add',
					serial_number:this.deviceTitle,
					name:this.devicePosition,
					agent_id:this.UserInfo.agent_id,
					unlock_state:this.doorValue,
					lock_mode:'0',
					lock_delay:'2',
					params_set:'1,0,0,0,0,0,0,1,0,1',
					serial:this.deviceInfo.serial,
					password:this.deviceInfo.password,
					support_face:this.deviceInfo.support_face,
					mac:this.deviceInfo.mac,
					btkey_type:this.deviceInfo.btkey_type,
					btkey:this.deviceInfo.btkey,
					device_no:this.deviceInfo.device_no,
					algorithm:this.deviceInfo.algorithm,
					device_type:this.deviceInfo.device_type,
					dept_id:this.dept_id,
					is_register:this.registerValue,
					factory:'',
					scan_open:this.deviceInfo.scan_open
				}
				this.$https(data).then(res=>{
					if(res.data.code==0){
						if(this.deviceInfo.network==1){
							Toast.success(this.$t('sbtjcgzzszwifics'))
							setTimeout(()=>{
								this.setWifiFun()
							},1000)
						}else{
							Toast.success(this.$t('sbtjcg'))
						}
					}else if(res.data.code==-4){
						if(this.deviceInfo.network==1){
							Toast.fail(this.$t('zzcxpzwifi'))
							this.bleSetWifi()
						}
						Toast.fail(this.$t('sbycz'))
					}else if(res.data.code==-5){
						Toast.fail(this.$t('tjsbsb'))
					}
				})
			},
			// 获取设备信息接口
			getDeviceInfo(name) {
				let data = {
					method: 'fvcard.device.info.get',
					serial_number: name
				}
				this.$hscp(data).then(res => {
					console.log(res.data);
					if (res.data.code == 0) {
						this.deviceInfo = res.data.data
						current_key = res.data.data.btkey
						if (this.deviceInfo.device_type == 0) {
							this.deviceType = this.$t('dt')
						} else {
							this.deviceType = this.$t('mj')
						}
					} else if (res.data.code == -3) {
						Toast.fail(this.$t('sbbcz'))
					}
				})

			},
			// 获取部门列表
			getDemp() {
				let data = {
					method: 'co.wx.dept.list',
					user_id: this.UserInfo.user_id,
			  agent_id: this.UserInfo.agent_id
				}
				this.$serve(data).then(res => {
					console.log(`5`, res.data.data)
					// var result = [];
					this.treeData=[]
					// if (res.data.data != null) result.push(this.getFirstObj(res.data.data));
					// this.treeData = result;
					for (let key in res.data.data) {
						console.log(res.data.data[key]);
						this.treeData.push(res.data.data[key])
					}
					// this.treeData=this.getFirstObj(res.data.data)
					// console.log(`6`,this.treeData)
				})
			},
			showDep() {
				this.show2 = true
				this.getDemp()
			},
			onSelect(selectedKeys, info) {
				console.log('selected', selectedKeys, info);
			},
			handleNodeClick(checkedKeys, info) {
				console.log(checkedKeys, info);
				console.log(checkedKeys.checked[checkedKeys.checked.length-1]);
				this.dept_id = checkedKeys.checked[checkedKeys.checked.length-1]
				if (info.checkedNodes.length == 1) {
					this.dept_name = info.checkedNodes[0].data.props.name
				} else {
					this.dept_name = info.checkedNodes[1].data.props.name
				}
				this.checkedSiteId = [].concat(checkedKeys.checked[checkedKeys.checked.length - 1]);
				this.dept_id = this.checkedSiteId[0]

				this.$nextTick(() => {
					if (this.checkedSiteId.length > 0) {
						this.siteActiveName = 'first';

					} else {
						//    return this.$message.info('请选择项目进行查询');
					}
				});
				console.log(this.dept_id);
			},
			goto() {
				this.$router.go(-1)
			},
			Blesdom() {
				current_device = null;
				console.log('Requesting any Bluetooth Device...');
				navigator.bluetooth.requestDevice({
						// acceptAllDevices: true,
						filters: [{
							namePrefix: 'awork'
						}],
						optionalServices: [
							'49535343-fe7d-4ae5-8fa9-9fafd205e455',
							"alert_notification",
							"automation_io",
							"battery_service",
							"blood_pressure",
							"body_composition",
							"bond_management",
							"continuous_glucose_monitoring",
							"current_time",
							"cycling_power",
							"cycling_power",
							"cycling_speed_and_cadence",
							"device_information",
							"environmental_sensing",
							"generic_access",
							"generic_attribute",
							"glucose",
							"health_thermometer",
							"heart_rate",
							"human_interface_device",
							"immediate_alert",
							"indoor_positioning",
							"internet_protocol_support",
							"link_loss",
							"location_and_navigation",
							"next_dst_change",
							"phone_alert_status",
							"pulse_oximeter",
							"reference_time_update",
							"running_speed_and_cadence",
							"scan_parameters",
							"tx_power",
							"user_data",
							"weight_scale"
						]
					})
					.then(device => {
						current_device = device;
						console.log(current_device)
						this.deviceTitle = (current_device.name).slice(6)
						let serial_number = (current_device.name).slice(6)
						this.getDeviceInfo(serial_number)
						// current_key = '4B08080A5D595345084B584D4E455C4D';
					})
					.catch(error => {
						console.log(error);
					});
			},
		}
	}
</script>

<style scoped>
	.addBox {
		padding: 10px;
		border: 1px solid #000;
		width: 90%;
		margin: 20px auto;
	}

	.addTitle {
		margin-bottom: 20px;
		font-size: 18px;
	}

	.lisone {
		display: flex;
		justify-content: space-evenly;
	}

	.margin_tops {
		margin-top: 15px;
	}

	.name {
		display: inline-block;
		width: 70px;
		text-align: left;
		line-height: 30px;
		/* flex: 2; */
	}

	.inputsp {
		flex: 4;
	}

	.btn {
		background-color: #1ABC9C;
		color: #fff;
		width: 100px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		border-radius: 5px;
		margin: 20px auto;
	}

	.inputsp input {
		height: 32px;
		width: 190px;
		padding: 2px 5px;
		border: 1px solid #7F7F7F;
		border-radius: 3px;
		background-color: #fff;
	}

	.inputsp span {
		margin-left: 5px;
		line-height: 25px;
		color: red;
		font-weight: bold;
		width: 5px;
		display: inline-block;
	}

	.inputsp select {
		height: 32px;
		width: 192px;
		border-radius: 3px;
		border: 1px solid #7F7F7F;
		background-color: #fff;
	}

	.inputBox {
		display: flex;
		justify-content: space-around;
		margin-bottom: 20px;
	}

	.title {
		display: flex;
		width: 94%;
		margin: 0 auto;
		padding: 8px 10px;
		justify-content: space-between;
		border-bottom: 1px solid #ccc;
		font-size: 14px;
		color: #666;
	}

	.liBox>>>.el-select-dropdown__item {
		padding-left: 10px;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
